module.exports = __webpack_public_path__ + "static/media/logo-white.1de6575c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.png
// module id = 1103
// module chunks = 0